<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <header class="text-center pb-4 border-b border-grey">
      <h3
        class="my-0 font-bold"
        v-text="'Delete Folder'"
      />
    </header>
    <div
      class="mt-4"
      v-text="'Deleting the folder will also erase all its contents!'"
    />
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn-red"
        @click="deleteFolder"
        v-text="'Delete'"
      />
      <a
        href="#"
        class="ml-4"
        @click.prevent="close"
        v-text="'Cancel'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'DeleteFolderModal',
  computed: {
    show() {
      return this.$store.state.document.deleteFolderModal.open
    },
    folder() {
      return this.$store.state.document.deleteFolderModal.folder
    },
  },
  methods: {
    deleteFolder() {
      const parentFolder = _.last(_.get(this.folder, 'ancestors.data', []))
      let redirect = this.$urlGenerator.active() + 'documents/'

      if (parentFolder) {
        redirect = redirect + 'folders/' + parentFolder.uuid
      }

      this.$api.active().delete(`folders/${this.folder.uuid}`)
        .then(() => {
          window.location = redirect
        })
    },
    close() {
      this.$store.commit('documentCloseDeleteFolderModal')
    },
  },
}
</script>
